import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import { useLocation, useNavigate } from "react-router-dom";

export interface PageElementErrorProps {
  selectedSite: any;
  errorAccToPageStatus: any;
  setOpen: any;
  open: any;
}
export default function AlertDialog({
  errorAccToPageStatus,
  setOpen,
  open,
}: PageElementErrorProps) {
  const location = useLocation();
  const navigate = useNavigate();

  const [, setIsEditPage] = React.useState(false);

  const handleClose = () => {
    setOpen(false);

    navigate(`/assets/page_management/`);
  };

  React.useEffect(() => {
    const extractEdit = () => {
      const parts = location?.pathname.split("/");
      const editPart = parts[parts.length - 1]; // Get the last part of the URL
      if (editPart === "edit") {
        setIsEditPage(true);
      }
    };
    extractEdit();
  }, [location]);

  const jsonString = errorAccToPageStatus?.parsedText?.reason;

  return (
    <>
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{ sx: { width: "900px", maxWidth: "350px" } }}
      >
        <DialogTitle id="alert-dialog-title">{jsonString}</DialogTitle>

        <DialogActions>
          <Button onClick={handleClose} autoFocus color="secondary">
            Back
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
